import { MouseEventHandler } from "react";

import useCanDoShop from "../../hooks/useCanDoShop.hook";

export default function SolidBtn({
  id,
  onClick,
  cap,
  children,
  type,
  dataRole,
}: // data-role
{
  id?: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  cap?: ShopCap;
  children: React.ReactNode;
  type?: "submit" | "button" | "reset";
  dataRole?: string;
}) {
  const canDo = useCanDoShop(cap);

  return (
    <button
      id={id}
      disabled={!canDo}
      type={type}
      onClick={onClick}
      data-role={dataRole}
      className="bg-her-dodgerblue text-white px-4 py-1 rounded cursor-pointer disabled:bg-her-aaa disabled:cursor-auto disabled:dark:bg-her-lightgray2 disabled:dark:text-her-aaa"
    >
      {children}
    </button>
  );
}
